//#region import
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml, RouterDOM, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPresentStatusID, EnumProjectStatusFinalScore, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { Router, useLocation, useNavigate } from 'react-router';
import { ApiProject } from 'enum/api';
import AccordionPanel from '../components/AccordionPanel';
import { FormProvider, useForm } from 'react-hook-form';
import PresentFrom from './PresentFrom';
import { CheckBoxItem } from 'components/Input/Checkbox/CheckBoxItem';
import moment from 'moment';
import { BtnApprove, BtnDraft, BtnSave, BtnSend } from 'components/Button/ButtonAll';
import { CheckBoxListItem } from 'components/Input/Checkbox/CheckBoxListItem';
import { CheckboxGroupFormItem } from '../components/CheckBoxGroup';
//#endregion

const Present404 = () => { //นำเสนอวิชาการ/ตีพิมพ์ 40(4) << สื่อเผยแพร่และประชาสัมพันธ์
    const {
        nProjectID,
        isPermission,
        nStatusID,
        isModeSecretary,
        ObjStepFlowProject,
        sPathNameBack,
        sMode,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();
    const Router = RouterDOM();

    //#region useState
    const [isEdit, setisEdit] = useState(false);
    const [nPresentStatusID, setnPresentStatusID] = useState(0);
    const [nPresentFormID, setnPresentFormID] = useState(0);

    const [dProjectStart, setdProjectStart] = useState(null);

    const [isBtn_DraftPresent, setisBtn_DraftPresent] = useState(false); //Requester >> บันทึกร่าง
    const [isBtn_SendPresent, setisBtn_SendPresent] = useState(false); //Requester >> รอเลขาตรวจสอบ
    const [isBtn_ConfirmSendPresent, setisBtn_ConfirmSendPresent] = useState(false); //เลขา >> เลขาตรวจสอบแล้ว

    const [lstPortfolioTypeID, setlstPortfolioTypeID] = useState([]); //ข้อมูลหัวข้อเงื่อนไข
    const [lstPresentTypeID, setlstPresentTypeID] = useState([]); //ข้อมูลหัวข้อ
    const [lstProjectPresent404, setlstProjectPresent404] = useState([]); //ข้อมูล

    const [sEmailFile, setsEmailFile] = useState(null); //ชื่อ Email แสดงใน Tab: สื่อเผยแพร่และประชาสัมพันธ์ < finance.dino.dmr@gmail.com  
    //#endregion

    const form = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            arrPortfolioID: [],
        } as any,
    });

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    useEffect(() => {
        if (ObjStepFlowProject !== null) setisEdit((ObjStepFlowProject?.isPermission_Tab9 && isModeSecretary) ? true : ObjStepFlowProject?.isPermission_Tab9 === true && sMode === "Present"); //Requester + หัวหน้าโครงการ + ผู้ประสานงาน
    }, [ObjStepFlowProject]);

    const GetFormInitial = async () => {
        await AxiosFn.Get(ApiProject.GetFormProjectPresent404, { nProjectID: nProjectID }, (result) => {
            setisBtn_DraftPresent(result.isBtn_DraftPresent); //Requester >> บันทึกร่าง
            setisBtn_SendPresent(result.isBtn_SendPresent); //Requester >> รอเลขาตรวจสอบ
            setisBtn_ConfirmSendPresent(result.isBtn_ConfirmSendPresent); //เลขา >> เลขาตรวจสอบแล้ว

            setlstPortfolioTypeID(result.lstPortfolioTypeID) //ข้อมูลหัวข้อเงื่อนไข
            setlstPresentTypeID(result.lstPresentTypeID) //ข้อมูลหัวข้อ
            setlstProjectPresent404(result.lstProjectPresent404); //ข้อมูล

            setdProjectStart(moment(result.nDateProjectStart)); //วันที่เริ่มต้นโครงการ
            setnPresentStatusID(result.nPresentStatusID);
            setnPresentFormID(result.nPresentFormID);
            // setlstnPortfolioID(result.lstnPortfolioID);//ข้อมูล หัวข้อเงื่อนไข ถูกเลือก Edit
            if ((result.lstnPortfolioID || []).length > 0) form.setValue("arrPortfolioID", (result.lstnPortfolioID || []).map(m => (m + "")));

            setsEmailFile(result.sEmailFile); //ชื่อ Email แสดงใน Tab: สื่อเผยแพร่และประชาสัมพันธ์ < finance.dino.dmr@gmail.com            
        });
    }

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectPresentStatusID, sStatusName: string) => {
        let lstnPortfolioID = DefaultArrayEmpty(form.getValues("arrPortfolioID")).map((m) => parseInt(m)); //ข้อมูลหัวข้อเงื่อนไข 
        if ((lstnPortfolioID || []).length === 0) {
            return DialogFn.Warning("กรุณาเลือกเงื่อนไขอย่างน้อย 1 หัวข้อ");
        }
        let lstProjectPresent = [...lstProjectPresent404].filter(f => f.isPresent === true);
        if ((lstProjectPresent || []).length === 0) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 หัวข้อ");
        }
        let param = {
            nProjectID: nProjectID,
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,
            nPresentFormID: nPresentFormID,
            lstPortfolioTypeID: lstPortfolioTypeID, //ข้อมูลหัวข้อเงื่อนไข  
            lstnPortfolioID: lstnPortfolioID, //ข้อมูลหัวข้อเงื่อนไข 
            lstProjectPresent404: lstProjectPresent404, //นำเสนอวิชาการ/ตีพิมพ์ 40(4) << สื่อเผยแพร่และประชาสัมพันธ์
        };
        DialogFn.Submit("คุณต้องการ" + sStatusName + "หรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPresent404, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(sStatusName + "สำเร็จ", () => {
                        if (nStatusID !== EnumProjectPresentStatusID.nPresentStatusID_0) handleBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleBack = () => {
        let sNameBack = "/Project";
        let sPathName = Router.GetCurrentRoute();
        if (sPathName === "/projectsrequestingfrom") sNameBack = "/ProjectList";
        navigate(sPathNameBack !== null ? sPathNameBack : sNameBack);
    }

    const GetPresentFrom = (isPresent, ObjProjectPresent, sNameFrom) => {
        return (
            <PresentFrom
                sMode={"404"}
                sNameFrom={sNameFrom}
                isEdit={isEdit}
                isPresent={isPresent && isEdit}
                ObjProjectPresent={ObjProjectPresent}
                dProjectStart={dProjectStart}
                lstPresent={ObjProjectPresent?.lstPresent ?? []}
                setlstPresent={(lstData) => {
                    if (ObjProjectPresent !== null) ObjProjectPresent.lstPresent = lstData;
                }}
                sEmailFile={sEmailFile}
            />
        );
    }

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} container spacing={1} justifyContent={'start'}>
                <Typography variant='h6' color={'#225192'}>ผลงานโครงการตามมาตรา 40 (4)</Typography>
            </Grid>
            <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' fontWeight="bold" color={'#0135d9'} style={{ textDecoration: "underline" }}>โปรดตรวจสอบว่าโครงการตามมาตรา 40 (4) ของท่านอยู่ในเงื่อนไขใด ดังต่อไปนี้</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingLeft: '3%', }}>
                            {/* <CheckBoxListItem
                                id={'arrPortfolioID'}
                                name={'arrPortfolioID'}
                                required={true}
                                label={``}
                                options={lstPortfolioTypeID}
                                disabled={!isEdit}
                            /> */}
                            <CheckboxGroupFormItem
                                name="arrPortfolioID"
                                id="arrPortfolioID"
                                isTooltip={false}
                                required={true}
                                label=""
                                AllowCheckAll={false}
                                disabled={!isEdit}
                                row={false}
                                options={lstPortfolioTypeID}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1' fontWeight="bold" color={'red'}>หากโครงการตามมาตรา 40 (4) ของท่านอยู่ในเงื่อนไขอย่างใดอย่างหนึ่งที่กล่าวมาข้างต้น กองทุนฯ ขอความอนุเคราะห์ท่านดำเนินการจัดทำ/จัดกิจกรรมอย่างใดอย่างหนึ่ง (เลือกได้มากกว่า 1 ข้อ) ดังนี้</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={12} container spacing={2}>
                            {(lstPresentTypeID || []).map((iPresentType) => {
                                let lstProjectPresent = lstProjectPresent404.filter(f => f.nPresentTypeID === iPresentType.value);
                                let ObjProjectPresent = (lstProjectPresent || []).length > 0 ? lstProjectPresent[0] : null;
                                let sName = iPresentType.value;

                                return (
                                    <Grid item xs={12} md={12} container spacing={1} key={"iPresentType_" + iPresentType.value} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={12}>
                                            <CheckBoxItem
                                                id={"isPresent_" + sName}
                                                name={"isPresent_" + sName}
                                                options={[iPresentType]}
                                                required={false}
                                                disabled={!isEdit}
                                                defaultValue={ObjProjectPresent?.isPresent ?? false}
                                                onChange={(e) => {
                                                    if (ObjProjectPresent !== null) ObjProjectPresent.isPresent = e;
                                                    setlstProjectPresent404(value => [...value]);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            {GetPresentFrom((ObjProjectPresent?.isPresent ?? false), ObjProjectPresent, sName)}
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="center" style={{ paddingBottom: '1%', paddingTop: '1%', }}>
                            {isBtn_DraftPresent &&
                                //Requester >> บันทึกร่าง
                                <Grid item>
                                    <BtnDraft
                                        id="BtnDraft_Present403"
                                        txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)}
                                        onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft, EnumProjectPresentStatusID.nPresentStatusID_0, I18n.SetText("Button.Draft", I18NextNs.labelComponent)), (err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })}
                                    />
                                </Grid>
                            }
                            {isBtn_SendPresent &&
                                //Requester >> รอเลขาตรวจสอบ
                                <Grid item>
                                    <BtnSave
                                        id="BtnSubmit_Present403"
                                        txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)}
                                        onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectPresentStatusID.nPresentStatusID_1, I18n.SetText("Button.Save", I18NextNs.labelComponent)), (err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })}
                                    />
                                </Grid>
                            }
                            {(isBtn_ConfirmSendPresent && isModeSecretary === true && isPermission) &&
                                //เลขา >> เลขาตรวจสอบแล้ว
                                <Grid item>
                                    <BtnApprove
                                        id="BtnConfirm_Present403"
                                        txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)}
                                        onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Approve, EnumProjectPresentStatusID.nPresentStatusID_2, I18n.SetText("Button.Confirm", I18NextNs.labelComponent)), (err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })}
                                    />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
        </Grid>
    )
}
export default Present404;